import type { PdpConfig } from '#types/config/pages/pdp'
import type { RecursivePartial } from '#types/utils'

export default {
  allowPreselectShoeSize: true,
  brandClasses: {
    breadcrumbs: '',
    details: 'lg:col-span-4 md:(col-span-5 row-start-2 row-end-5)',
    detailsSticky: 'md:pt-4',
    eSpotLazyAboveFooter: 'mt-4',
    eSpotsAndReviews: 'mt-4 md:mt-8 space-y-8',
    gallery: 'lg:col-span-8 md:(col-span-7 row-start-1 row-end-3 pt-4) <md:-mx-3',
    grid: 'mb-12 md:(grid mb-8 items-start gap-4 cols-12)',
    gridFullWidth: 'col-span-12',
    gridPartialWidth: 'lg:col-span-8 md:col-span-7',
    heading: 'pt-4 lg:col-span-4 md:col-span-5 <lg:mb-4',
    headingProductBadge: 'mb-2 bg-grey-80',
    headingProductName: 'title-2',
    headingSticky: 'mb-8 lg:mb-4',
    paypalPayments: 'my-4',
    reviewsCount: 'hidden',
    reviewsItemsContainer: 'space-y-3',
    reviewsListContainer: 'space-y-3',
    reviewsSearchForm: 'b b-grey-40 rounded-xs focus-within:b-grey-10',
    reviewsSearchInput: 'w-full b-0',
    reviewsSearchSortContainer: 'py-3 space-y-3',
    reviewsSearchSubmit: 'px-3',
    reviewsSearchWrapper: '',
    variantSelectionWrapper: 'b-none pt-4 space-y-4',
    reviewsSnapshotWrapper: 'space-y-3',
    reviewsWrapper: 'text-sm',
    shopTheLookHeading: 'md:text-center',
    shopTheLookDialog: 'lg:w-100',
    shopTheLookWrapper: 'my-16',
    upsellsWrapper: 'my-6'
  },
  breadcrumbsMaxItems: 2,
  details: {
    ctaSize: 'sm',
    ctaVariant: 'secondary',
    favoriteCta: {
      hideWhenNotifyMe: true,
      iconSize: 'md',
      iconOnly: true,
      variantSelected: 'transparent'
    },
    findInStoreCta: {
      showIcon: false
    }
  },
  disableGroupBy: true,
  eSpotsWithPageContext: ['lazy-above-footer'],
  gallery: {
    presets: {
      src: {
        alignFill: 'center',
        width: 458,
        height: 573,
        unSharpMask: 100
      },
      srcLarge: {
        width: 1152,
        height: 648,
        unSharpMask: 100,
        align: 'center',
        backgroundAuto: 'border:horizontal'
      },
      srcZoom: {
        alignFill: 'center',
        width: 2000,
        height: 2500,
        excludeDPR: true,
        sharpen: 0
      }
    },
    imageSource: {
      lg: 'srcLarge'
    }
  },
  hideGiftCardBreadcrumbs: true,
  questions: {
    pageSize: 10
  },
  quickshop: {
    dialogOptions: {
      type: 'panel',
      position: { sm: 'bottom', lg: 'right' },
    }
  },
  reviews: {
    dialogOptions: {
      reviewWrite: { type: 'panel' },
      filters: { type: 'panel' }
    },
    pageSize: 10,
    iconSize: 'md',
    showFilters: true,
    showProsAndCons: false,
    showRatingBreakdown: false,
    showWriteReviewCta: false
  },
  seoMetaImage: '/img/logos/vans/default.svg',
  shopTheLook: {
    dialogOptions: { type: 'panel', size: { sm: 'lg', lg: 'sm' } },
    mediaSize: {
      width: 120,
      height: 150
    },
    mediaTransformations: {
      alignFill: 'center',
      unSharpMask: 100
    },
    showLinkArrow: true,
    quickshopIcon: 'plus',
  },
  showBreadcrumbsLastStep: false,
  sizeAndFit: {
    showFitRating: false,
    showHeading: false,
    showModelMeasurements: false,
    showSizeChartIcon: false
  },
  sizeChart: {
    dialogOptions: { type: 'panel' }
  },
  stickyHeader: {
    thumbnail: {
      height: 80,
      width: 64
    }
  },
  swatches: {
    variant: 'rectangle'
  },
  tryItOn: {
    apparelUrl: 'https://sneaker-window.vyking.io/vyking-assets/customer/{brand}/ar-asset-packages/{productId}/offsets.json',
    brandClasses: {
      subtitle: 'text-sm fw-bold my-4 <md:hidden',
      vyking: '[&::part(qrcode)]:(relative w-full ws-pre-wrap left-a top-a flex transform-none text-left text-sm lh-2) [&::part(qrcode-img)]:w-40 [&::part(qrcodeCaption)]:m-4'
    },
    config: '/vyking/modeld-3.bin',
    dialogOptions: { type: 'panel' },
    key: 'com.vans',
    src: 'https://sneaker-window.vyking.io/vyking-apparel/1/vyking-apparel.js'
  },
  variantSelection: {
    dialogOptions: {
      size: { sm: 'sm', lg: 'full' }
    }
  }
} satisfies RecursivePartial<PdpConfig>
